<!--<div class="notifications-container">
  <div class="popup">
    <div class="popup-content">
      <div class="heading-part">
        <h1>Notifications</h1>
        <p class="new-text" *ngIf="totalUnreadCount > 0">{{ totalUnreadCount }} new</p>
        <p class="marked-read handPointer" *ngIf="totalUnreadCount > 0" (click)="markAllAsRead(1)">Marked as Read</p>
        <img class="close" src="../../../../assets/images/close-circle.svg" (click)="onClose()" />
      </div>
      <div class="notification-textss handPointer {{ !notification.isRead ? 'background_unread' : '' }}"
        *ngFor="let notification of notificationLists; let i = index" (click)="markAllAsRead(notification)"
        infiniteScroll [infiniteScrollDistance]="10" [infiniteScrollThrottle]="150" (scrolled)="onScroll($event)">
        <p class="main ellipsis">{{ notification?.notification?.message || '--' }}</p>
        <p>{{ notification?.notification?.message || '--' }}</p>
         <p class="date">{{ dateInMilisecond(notification?.createdAt) | dateAgo }}</p>

        <p class="date">{{ notification?.createdAt | date: 'MMMM dd, YYYY | hh:mm a' }}</p>
      </div>

      <div class="searchResult" *ngIf="pagination.row == 0 && pagination.text != 'Loading...'">
        <div class="searching text-center">
          <h5>{{ pagination.text || '' }}</h5>
        </div>
      </div>
    </div>
  </div>
</div>-->
<!---- offcanvas code ---->
<div class="notifications-container">
  <div class="heading-part">
    <div class="heading-part-left">
      <h4>Notifications</h4>
      <p class="new-text" *ngIf="totalUnreadCount > 0">{{ totalUnreadCount }} new</p>
    </div>
    <p class="marked-read handPointer heading-part-right" *ngIf="totalUnreadCount > 0" (click)="markAllAsRead(1)">Mark as Read</p>
    <!-- <img class="close" src="../../../../assets/images/close-circle.svg" (click)="onClose()" /> -->
    <span class="close" (click)="onClose()" [innerHTML]="ICONS.closeCircleIcon | safeHtml"></span>
  </div>
  <div
    class="height100"
    *ngIf="notificationLists?.length > 0"
    [scrollWindow]="false"
    infiniteScroll
    [infiniteScrollDistance]="10"
    [infiniteScrollThrottle]="150"
    (scrolled)="onScroll($event)"
  >
    <div
      class="notification-textss handPointer {{ !notification.isRead ? 'background_unread' : '' }}"
      *ngFor="let notification of notificationLists; let i = index"
      (click)="!notification.isRead ? markAllAsRead(notification) : null; getDetail(notification)"
    >
      <p class="main ellipsis">{{ notification?.notification?.title || '--' }}</p>
      <p class="notification-msg" [innerHTML]="replaceText(notification?.notification?.message || '', notification?.notification)"></p>
      <!-- <p class="date">{{ dateInMilisecond(notification?.createdAt) | dateAgo }}</p> -->

      <p class="date">{{ notification?.createdAt | date: 'MMMM dd, YYYY | hh:mm a' }}</p>
    </div>
  </div>
  <div class="searchResult" *ngIf="pagination.row == 0 && pagination.text != 'Loading...'">
    <div class="searching text-center">
      <h5>{{ pagination.text || '' }}</h5>
    </div>
  </div>
</div>
